/* eslint-disable max-len */
import { activityId, activityName } from '@/client/lib/time/config';

export const language = {
  en: {
    title: 'Invite Friends',
    title1: 'Invite new friends and earn',
    invite20: 'Invite ${1} friends, you can earn up to Rp ${0}.',
    myCode: 'My invitation code',
    copy: 'Copy',
    inviteBtn: 'Invite',
    copySuccess: 'Copied successfully, let\'s invite friends!',
    copyCodeSucc: 'Invitation code copied successfully',
    revenue: 'Invitation revenue',
    revenueItem1: 'Estimated revenue',
    revenueItem2: 'Earned revenue',
    revenueItem3: 'Friends invited',
    withdraw: 'Withdraw',
    end: 'Expired',
    acitityEnd: 'Event has expired',
    how: 'How to earn Rp ${0}',
    how1: 'Friends bind your invitation code',
    how2: 'Friends watch the video for another 2 days, 15 minutes per day',
    how3: 'Friends keep watching videos',
    howRp: 'Earn up to Rp ${0}',
    howIntro1: 'Invite new users, after verification, you can get rewards Rp ${0} on the first day.',
    howIntro2:
      'After successfully inviting a new friend, he needs to watch the video continuously for 3 days and more than 15 minutes in Snack Video, and you get coins.',
    howIntro2_r:
      'After successfully inviting a new friend, he needs to watch the video continuously for 3 days and more than 15 minutes in Snack Video, and you get cash.',
    howIntro3:
      'Friends keep watching the video, you get rewards every day, and each friend can earn up to Rp ${0} for you.',
    step: 'Earn money in 3 steps',
    step1: 'Share to friends on the social platform',
    step2: 'Friends download and login to Snack Video',
    step3: 'Friend bind invitation code successfully',
    btmTitle: 'Invite friends and earn money',
    copyBtn: 'Copy link',
    cancel: 'Cancel',
    inviteCodeStr:
      '1. The invitation code is [${0}].\nCopy the whole text to the clipboard.\n2. Tap the link below to open/install Snack. (recommend way)\n',
    remind: 'Remind',
    reminded: 'Reminded',
    got: 'Got ${0}',
    remindToast: 'Message sent successfully',
    rp: 'Rp ${0}',
    more: 'More',
    less: 'Less',
    noMore: 'You can check all income in \'My Coins\'',
    noMore_r: 'You can check all income in \'Cash Balance\'',
    pauseTitle: 'Activity suspended temporarily',
    pauseContent: 'You can withdraw cash balance at any time',
    pauseBtn: 'View Announcement',
    panelTitle: 'Share this activity with friends',
    rule: 'Rules',
    gradientTitle1: 'Invite ${0} friends and get',
    gradientTitle2: 'the rewards are unlimited!',
    activityTime: 'Activity time: ${0}',
    total: 'Total',
    gradientMore: 'more',
    gradientBtn: 'Invite and earn ${0}',
  },

  id: {
    title: 'Mengundang teman-teman',
    title1: 'Undang pengguna baru dan pasti dapatkan',
    invite20: 'Undang ${1} teman, Anda bisa mendapatkan paling banyak Rp ${0}.',
    myCode: 'Kode undangan saya',
    copy: 'Salin',
    inviteBtn: 'Undang Teman',
    copySuccess: 'Berhasil disalin, mari undang teman!',
    copyCodeSucc: 'Berhasil disalin, mari undang teman!',
    revenue: 'Pendapatan undangan',
    revenueItem1: 'Estimasi pendapatan',
    revenueItem2: 'Pendapatan yang diperoleh',
    revenueItem3: 'Teman diundang',
    withdraw: 'Tarik Saldo',
    end: 'Kedaluwarsa',
    acitityEnd: 'Acara telah berakhir',
    how: 'Cara mendapatkan Rp ${0}',
    how1: 'Teman mengisi kode undangan Anda',
    how2: 'Teman-teman menonton video selama 2 hari lagi, 15 menit per hari',
    how3: 'Teman terus menonton video',
    howRp: 'Hasilkan hingga Rp ${0}',
    howIntro1:
      'Undang pengguna baru, setelah verifikasi berhasil, Anda bisa mendapatkan hadiah ${0} koin di hari pertama.',
    howIntro2:
      'Setelah berhasil mengundang teman baru, ia perlu menonton video berlangsung selama 3 hari dan lebih dari 15 menit setiap hari di SnackVideo, dan Anda mendapatkan koin.',
    howIntro2_r:
      'Setelah berhasil mengundang teman baru, ia perlu menonton video berlangsung selama 3 hari dan lebih dari 15 menit setiap hari di SnackVideo, dan Anda mendapatkan uang.',
    howIntro3:
      'Teman terus menonton video, Anda mendapatkan hadiah setiap hari, dan setiap teman bisa menghasilkan Anda hingga ${0} koin.',
    step: 'Hasilkan uang dalam 3 langkah',
    step1: 'Bagikan ke teman di sosial mediamu',
    step2: 'Teman mengunduh dan masuk ke Snack Video',
    step3: 'Kode undangan berhasil mengikat teman',
    btmTitle: 'Undang teman dan dapatkan uang',
    copyBtn: 'Salin tautan',
    cancel: 'Batalkan',
    inviteCodeStr:
      '1. Kode undangan adalah [${0}].\n Salin seluruh teks ke clipboard.\n2. Ketuk tautan di bawah ini untuk membuka / menginstal Snack. (cara yang disarankan)\n',
    remind: 'Mengingatkan',
    reminded: 'Dikirim',
    got: 'Punya ${0}',
    remindToast: 'Pesan berhasil dikirim',
    rp: 'Rp ${0}',
    more: 'Lengkap',
    less: 'Kurang',
    noMore: 'Anda dapat memeriksa semua pendapatan di \'Koin Saya\'',
    noMore_r: 'Anda dapat memeriksa semua pendapatan di \'Saldo Saya\'',
    pauseTitle: 'Aktivitas ditangguhkan sementara',
    pauseContent: 'Anda dapat menarik saldo tunai kapan saja',
    pauseBtn: 'Lihat Pengumuman',
    panelTitle: 'Bagikan aktivitas ini dengan teman-teman',
    rule: 'Peraturan',
    gradientTitle1: 'Undang ${0} teman dan dapatkan',
    gradientTitle2: 'imbalannya tidak terbatas!',
    activityTime: 'Waktu kegiatan: ${0}',
    total: 'Total',
    gradientMore: 'lebih',
    gradientBtn: 'Undang & dapatkan ${0}',
  },
};

export const platformConf = [
  {
    name: 'Whatsapp',
    platform: 'whatsapp',
    icon: 'share_whatsapp',
  },
  {
    name: 'Facebook',
    platform: 'facebook_bulldog',
    icon: 'share_facebook',
  },
  {
    name: 'Facebook Story',
    platform: 'facebook_story',
    icon: 'share_facebook',
  },
  {
    name: 'Instagram',
    platform: 'instagram',
    icon: 'share_ins',
  },
  {
    name: 'copy',
    platform: 'copy_link',
    icon: 'share_copy',
  },
];

export const activityConfig = {
  page: 'INVITE_NEW_USER_H5',
  activity_id: activityId,
  activity_name: activityName,
};

export const imgHost = 'https://d3qrssutfqv0j9.cloudfront.net/udata/pkg/proweb/friends';

// export const ONELINK_URL = 'https://go.onelink.me/kQdi/Snackinvitation';
export const ONELINK_URL = 'https://snack-ios.onelink.me/hpTj/d8c87458';
